import React, { useState, useEffect } from "react";
import { observer } from "mobx-react-lite";
import { LookupStore } from "Stores/Domain/LookupStore";
import { container } from "tsyringe";
import { AutoGrid, Box, ThemedCheckBox, ThemedComboBox, ThemedButton, ThemedText, ThemedEditText, ThemedEditDate, ThemedRadioButtons, setPageTitle } from "Application";
import { StagesViewModel } from "./StagesViewModel";

interface Props {
    viewModel: StagesViewModel;
}
export const StagesView: React.FC<Props> = observer((props: Props) => {
    const { viewModel } = props;
    const lookupStore = container.resolve(LookupStore);
    useEffect(() => {
        setPageTitle("Stages");
    }, []);

    return (
        <Box p={3}>
            <ThemedText fontStyle="h3">Page Name: Stages</ThemedText>
            <Box grid dc="1fr 1fr 1fr" mt={3}>
                <ThemedText>{viewModel.getValue("status")}</ThemedText>
                <ThemedText>{viewModel.getValue("title")}</ThemedText>
                <ThemedText>{viewModel.getValue("updatedDate")}</ThemedText>
                <ThemedText>{viewModel.getValue("description")}</ThemedText>
            </Box>
        </Box>
    );
});
